import { render, staticRenderFns } from "./unitCard.vue?vue&type=template&id=494d6a02&scoped=true"
import script from "./unitCard.vue?vue&type=script&lang=js"
export * from "./unitCard.vue?vue&type=script&lang=js"
import style0 from "./unitCard.vue?vue&type=style&index=0&id=494d6a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d6a02",
  null
  
)

export default component.exports